import BaseService from './BaseService'
import axios from 'axios'

export default class UserService extends BaseService {
  static async me () {
    const resp = await axios.get('/api/v1/protected/users')

    return this.parseResponse(resp, false)
  }

  static async getSkills () {
    const resp = await axios.get('/api/v1/protected/users/skills')

    return this.parseResponse(resp, false)
  }

  static async getLearning () {
    const resp = await axios.get('/api/v1/protected/users/learnings')

    return this.parseResponse(resp, false)
  }

  static async getAvailableLearning () {
    const resp = await axios.get('/api/v1/protected/users/learnings/available')

    return this.parseResponse(resp, false)
  }

  static async createLearning (skillId) {
    const resp = await axios.post('/api/v1/protected/users/learnings', {
      user_learning: { skill_id: skillId }
    })

    return this.parseResponse(resp, false)
  }

  static async update (params) {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(`user[${key}]`, value);
    });

    const resp = await axios.put(`/api/v1/protected/users/${params.id}`, !!params.avatar ? formData : params)

    return this.parseResponse(resp, false)
  }

}
